<template>
  <div class="e-card__header-append">
    <b-dropdown right
                ref="dropdown"
                toggle-class="e-card__dropdown-toggle e-topbar__dropdown-toggle"
                menu-class="e-dropdown__menu e-dropdown__menu--right e-card__dropdown-menu"
                class="e-dropdown e-card__dropdown">
      <b-dropdown-item class="e-dropdown__item">Explore</b-dropdown-item>
      <b-dropdown-item class="e-dropdown__item" @click="moveElement">Move</b-dropdown-item>
      <b-dropdown-item class="e-dropdown__item">Delete</b-dropdown-item>
      <b-dropdown-item class="e-dropdown__item">Share</b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
	export default {
		name: "e-card-header",
    methods: {
      moveElement() {
        this.$emit('move');
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/card/cardHeader.vue